import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccountingDashboardSnapshot } from '@/renderer/services/accountingReportingService';

export function useAccountingDashboard(
  companyId: number | null,
  outletId: string | null | undefined,
  dateFrom: string,
  dateTo: string,
) {
  return useQuery({
    queryKey: queryKeys.accounting.dashboard(
      companyId ?? 0,
      outletId,
      dateFrom,
      dateTo,
    ),
    queryFn: async () => {
      const result = await fetchAccountingDashboardSnapshot(
        companyId!,
        outletId,
        dateFrom,
        dateTo,
      );
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to load accounting dashboard');
      }
      return result.data;
    },
    enabled: !!companyId,
    staleTime: 1000 * 60 * 5,
  });
}
